class Sidemenu {
	constructor(config) {
		this.config = Object.assign({
			scope: '[data-scope="sidemenu"]',
			parent: '[data-scope="menu-primary"]',
			dropdown: '.dropdown',
			child: '[data-scope="menu-secondary"]',
			close: '.button-close'
		}, config);

		this.$scope = $(this.config.scope);

		if(this.$scope.length > 0) {
			this.init();
		}
	}

	init() {
		this.initEventListeners()
	}

	initEventListeners() {
		this.$scope.on('mouseover', this.config.parent, this.openMenu.bind(this));
		this.$scope.on('click', `${this.config.parent} .icon-arrow-l`, this.openMenu.bind(this));
		this.$scope.on('mouseover', `.menu-item:not(${this.config.parent})`, this.closeMenu.bind(this));
		this.$scope.on('click', this.config.close, this.closeMenu.bind(this));
	}

	openMenu(e) {
		event.preventDefault();
		let $currentTarget = $(e.currentTarget);
		let $parent = $currentTarget;
		if($currentTarget.is('.icon-arrow-l')) {
			$parent = $currentTarget.closest(this.config.parent);
		}

		let menuIndex = $parent.data('menu');

		$('.secondary-menu').addClass('d-block');
		$('.dropdown-secondary-menu').removeClass('show');
		$('.menu-item').addClass('not-active');
		$parent.addClass('active');
		$parent.removeClass('not-active');
		this.resetMenus($parent);
		this.$scope.find(this.config.child + "[data-index="+ menuIndex +"]").addClass('show');
	}

	closeMenu(event) {
		$(this.config.child).removeClass('show');
		$('.secondary-menu').removeClass('d-block');
		$('.menu-item').removeClass('not-active');
		$('.menu-item').removeClass('active');
	}

	// Define the parent(menu, (and children)) that should not be reset, leave null if all should reset.
	resetMenus($parent = null) {
		this.resetParents($parent);
		this.resetChilds($parent);
	}

	resetParents($parent) {
		this.$scope.find(this.config.parent).each(function (i) {
			if ($parent !== null) {
				let menuIndex = $parent.data('menu');
				if ($(this).data('menu') !== menuIndex) {
					$(this).removeClass('active');
				}
			} else {
				$(this).removeClass('active');
			}
		});
	}

	resetChilds($parent) {
		this.$scope.find(this.config.child).each(function (i) {
			if ($parent !== null) {
				let menuIndex = $parent.data('menu');
				if ($(this).data('menu') !== menuIndex) {
					$(this).removeClass('show');
				}
			} else {
				$(this).removeClass('show');
			}
		});
	}
}

export default new Sidemenu;
